import styled, { css } from 'styled-components'

export const CircleDotWrapper = styled.ul<{ maxDotsToShow: number }>(({ maxDotsToShow }) => css`
  display: flex;
  align-items: center;
  height: 100%;
  transition: transform 0.3s ease 0s;
  max-width: ${maxDotsToShow * 16}px;
  margin: 0 auto;
  list-style: none;
  padding: 0;
`)

type CircleDotItemProps = {
  containsVideo?: boolean
  isActive?: boolean
  outOfBounds?: boolean
}

export const CircleDotItem = styled.li<CircleDotItemProps>(({ containsVideo, isActive, outOfBounds }) => css`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  margin: 3px;
  flex-shrink: 0;
  border: solid 1px rgba(124, 124, 124, 0.8);
  background-color: rgba(255, 255, 255, 0.86);
  opacity: 0.7;
  transition: opacity 0.45s ease 0.15s;

  ${isActive && css`
    border-color: rgba(255, 255, 255, 0.75);
    background-color: rgba(56, 56, 56, 0.8);
    width: 12px;
    height: 12px;
    opacity: 1;
  `}

  ${outOfBounds && css`
    opacity: 0;
  `}

  ${containsVideo && css`
    width: 14px;
    height: 14px;
    margin: 0;
    position: relative;

    &:after {
      position: absolute;
      display: block;
      content: ' ';
      width: 0;
      height: 0;
      z-index: 10;
      left: 4px;
      top: 2px;
      border-width: 4px 0px 4px 5px;
      border-color: transparent transparent transparent rgb(158, 158, 158);
      border-style: solid;
      pointer-events: none;

      ${isActive && css`
        border-right-color: rgba(255, 255, 255, 0.75);
      `});
    }`}
`)
